import {
  Box,
  Input,
  Link,
  Paper,
  Table,
  TableCell,
  TableContainer,
  Button,
  IconButton,
  Tooltip,
  Grid,
  ButtonBase,
} from '@material-ui/core';
import React from 'react';
import KenDateTimePicker from '../../global_components/KenDateTimePicker';
import { facultyDropDown } from '../../Pages/AdminPortal/Exam/Invigilation/InvigilationAssign';
import KenSelect from '../../global_components/KenSelect';
import InfoIcon from '@material-ui/icons/Info';
import KenInputField from '../KenInputField';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
  error: {
    // color: '#F14B2D',

    background: 'orange',
    // background: 'white',
    // background: '#EB5757',

    borderRadius: '25px',
    // border: '1px solid white',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: 'white',
    height: '23px',
    width: '115px',

    '&:hover': {
      color: 'white',
      background: 'orange',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  normal: {
    // color: '#505F79',
    color: 'white',

    background: 'green',
    // background: '#27AE60',

    // background: 'white',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    height: '23px',
    width: '115px',

    '&:hover': {
      background: 'green',

      color: 'white',
      // border: '1px solid white',
    },
  },

  normal1: {
    // color: '#505F79',
    color: '#000',

    // background: 'rgba(138, 245, 196,0.4)',
    // background: '#27AE60',

    // background: 'white',

    // borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '5px 5px',
    // height: '23px',
    // width: '115px',
  },
  medium: {
    color: 'white',
    background: '#55b0cd',
    textDecoration: 'none',

    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      background: '#55b0cd',
      color: '#f17100',
    },
  },
}));
const KenGridEditableData = ({
  row,
  name,
  onChange,
  type,
  columns,
  rowName,
  dropdown,
  style,
}) => {
  const { isEditMode } = row;

  const classes = useStyles();

  console.log('row', row);
  const {
    eligibility_status,
    status,
    document_submitted,
    revFacultyList,
    revalAccept,
  } = row;

  console.log({ eligibility_statussssssssssss: eligibility_status });

  let classOfBtn;
  if (eligibility_status === 'At Risk') {
    classOfBtn = classes.medium;
  } else if (eligibility_status === 'Not eligible') {
    classOfBtn = classes.error;
  } else if (eligibility_status === 'Eligible') {
    classOfBtn = classes.normal;
  } else if (eligibility_status === 'Under Review') {
    classOfBtn = classes.medium;
  }

  if (status === 'Completed') {
    classOfBtn = classes.normal;
  } else if (status === 'Pending') {
    classOfBtn = classes.error;
  }

  if (document_submitted === 'Submitted') {
    classOfBtn = classes.normal;
  } else if (document_submitted === 'Not Submitted') {
    classOfBtn = classes.error;
  }

  if (revFacultyList) {
    classOfBtn = classes.normal1;
  } else {
    classOfBtn = classes.normal1;
  }
  // const classes = useStyles();
  const regex = /^[ ABCabcFf./#&+-]*$/;

  return columns.map((ele) => {
    if (ele.inline_edit_type == 'kenDatePicker') {
      console.log('rating', ele);
      return (
        <TableCell align="left">
          {isEditMode ? (
            <KenDateTimePicker
              name={ele.column_name}
              label={ele.label}
              placeholder="Start Date"
              value={row[ele.column_name]}
              type="date"
              required={true}
              onChange={(e) => onChange(e, row)}
            />
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type === 'kenTime') {
      if (isEditMode) {
        if (ele.column_name === 'start_time') {
          const start_time = moment(row[ele.column_name], ['h:mm A']).format(
            'HH:mm'
          );

          row[ele.column_name] = start_time;
        }
        if (ele.column_name === 'end_time') {
          const end_time = moment(row[ele.column_name], ['h:mm A']).format(
            'HH:mm'
          );
          row[ele.column_name] = end_time;
        }
      }
      return (
        <TableCell align="left">
          {isEditMode ? (
            <>
              <KenDateTimePicker
                name={ele.column_name}
                label={ele.label}
                placeholder={ele.label}
                value={row[ele.column_name]}
                type="time"
                required={true}
                onChange={(e) => onChange(e, row)}
              />
            </>
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenSelect') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Box>
              <KenSelect
                name={ele.column_name}
                options={ele.dropdown}
                value={row[ele.column_name]}
                dropdownColor="#ffffff"
                onChange={(e) => onChange(e, row)}
                required={true}
                label={ele.label}
              />
            </Box>
          ) : (
            <Button
              variant="primary"
              // component={Link}
              className={classOfBtn}
              // to={`${routes.invigilationProctoring}/${id}`}
            >
              {row[ele.column_name]}{' '}
            </Button>
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenInput') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Input
              value={row[ele.column_name]}
              name={ele.column_name}
              onChange={(e) => onChange(e, row)}
              disabled={ele.disable_input}
            />
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenInput1') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <>
              <Grid
                container
                style={{ paddingBottom: '10px' }}
                className="Tets"
                spacing={1}
              >
                {' '}
                <Grid item xs={11}>
                  <Input
                    value={row[ele.column_name]}
                    name={ele.column_name}
                    onChange={(e) => onChange(e, row)}
                  />{' '}
                </Grid>
                <Grid style={{ marginLeft: '-14%', color: '#000' }} item xs={1}>
                  <Tooltip
                    className="test3434"
                    arrow
                    title="The Grade Should be in A,B,C or F Only"
                  >
                    <IconButton style={{ padding: '0px' }}>
                      {' '}
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>

              {console.log(
                'row[ele.column_name]row[ele.column_name]row[ele.column_name]',
                row[ele.column_name]
              )}
              {row[ele.column_name] !== null &&
                typeof row[ele.column_name] !== 'number' &&
                !row[ele.column_name].match(regex) && (
                  <span
                    style={{
                      color: 'red',
                      fontSize: '10px',
                      fontWeight: 'bold',
                    }}
                  >
                    {' '}
                    The Grade Should be in A,B,C or F Only{' '}
                  </span>
                )}
            </>
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else {
      return <TableCell>{row[ele.column_name]}</TableCell>;
    }
  });
};

export default KenGridEditableData;
